import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import Pagination from "../Pagination/Paginations.js";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import EntriesSelector from "../Pagination/EntriesSelector";
import "../preloading.css";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const PfReport = () => {
const today = new Date().toLocaleDateString("en-CA").slice(0, 7);
  const [filters, setFilters] = useState({
start_date: today, // format: yyyy-mm    dept_id: "0",
    action_type: "Fetch",
  });

  const [departments, setDepartments] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  // ✅ Handle input changes
  const handleInput = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Fetch departments
  const fetchDepartments = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/showdepartment", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

      let deptData = [];
      if (Array.isArray(res.data)) deptData = res.data;
      else if (res.data.departments) deptData = res.data.departments;
      else if (res.data.data) deptData = res.data.data;
      else toast.error("Unexpected response format from /showdepartment");

      setDepartments(deptData);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load departments");
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  // ✅ Fetch PF Report
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(
        API_BASE_URL + "/pf_report",
        {
          start_date: filters.start_date,
          dept_id: filters.dept_id,
          action_type: filters.action_type,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      setRecords(res.data.records || []);
      setCurrentPage(1);
      toast.success("PF report loaded successfully!", {
        position: "bottom-right",
        theme: "colored",
      });
    } catch (error) {
      console.error(error);
      toast.error("Error fetching PF report");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Filter + Pagination
  const filteredItems = records.filter((item) =>
    `${item.employee_id}${item.employee_name}${item.department_name}${item.uan_no}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  return (
    <>
      <div className="container-fluid mt-4">
        <ToastContainer />

        {/* 🔹 Header Navigation */}
        <div className="mb-3 d-flex flex-wrap gap-2">
          <a href="/pf-report" className="btn btn-info btn-sm">
            PF REPORT
          </a>
          <a href="/Esi-report" className="btn btn-outline-secondary btn-sm">
            ESI REPORT
          </a>
        </div>

        {/* 🔹 Filter Card */}
        <div className="card shadow-sm mb-4">
          <div className="card-header with-elements">
            <span className="card-header-title me-2">PF Report Filter</span>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row g-3 align-items-end">
                {/* Month Picker */}
              <div className="col-md-3">
  <label>Select Month</label>

  <DatePicker
    selected={
      filters.start_date
        ? new Date(filters.start_date + "-01") // convert yyyy-mm to valid Date
        : null
    }
    onChange={(date) => {
      const value = date
        ? date.toLocaleDateString("en-CA").slice(0, 7) // yyyy-mm
        : "";

      setFilters((prev) => ({
        ...prev,
        start_date: value,
      }));
    }}
    dateFormat="yyyy-MM"
    showMonthYearPicker
    placeholderText="Select Month"
    className="form-control"
  />
</div>



                {/* Department */}
                <div className="col-md-3">
                  <label htmlFor="dept_id">Department</label>
              <Select
    name="dept_id"
    
    value={
      departments
        .map((dept) => ({
          value: dept.department_id || dept.id,
          label: dept.department_name,
        }))
        .find((d) => d.value === filters.dept_id) || null
    }
    onChange={(selected) =>
      handleInput({
        target: {
          name: "dept_id",
          value: selected ? selected.value : "0",  // same as All Department
        },
      })
    }
    options={departments.map((dept) => ({
      value: dept.department_id || dept.id,
      label: dept.department_name,
    }))}
    isClearable
    placeholder="All Department"
    className="basic-single"
  />
                </div>

                {/* Action */}
                

                {/* Submit */}
                <div className="col-md-2">
                  <button type="submit" className="btn btn-primary w-100 mt-2">
                    {loading ? "Loading..." : "Get"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* 🔹 Table Section */}
        <div className="card">
          <h6 className="card-header text-danger">PF Report</h6>
          <div className="card-body">
            {/* Controls */}
            <div className="d-flex justify-content-between mb-2 align-items-center">
              <div className="d-flex align-items-center gap-2">
                <DownloadButtons data={filteredItems} filename="PF_Report" />
                <EntriesSelector
                  setEntriesPerPage={setEntriesPerPage}
                  setCurrentPage={setCurrentPage}
                />
              </div>

              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search..."
                style={{ width: "200px" }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* Table */}
            {loading ? (
              <div className="d-flex justify-content-center p-5">
                <div className="spinner"></div>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered table-striped text-center">
                  <thead style={{ backgroundColor: "#7d858369" }}>
                    <tr>
                      <th>Employee ID</th>
                      <th>Employee Name</th>
                      <th>Department</th>
                      <th>Basic Salary</th>
                      <th>Actual PF Employer</th>
                      <th>Actual PF Employee</th>
                      <th>Calculated PF Employer</th>
                      <th>Calculated PF Employee</th>
                      <th>UAN No</th>
                      <th>Payment Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.employee_id}</td>
                          <td>{row.employee_name}</td>
                          <td>{row.department_name}</td>
                          <td>{row.basic_salary}</td>
                          <td>{row.actual_pf_employer}</td>
                          <td>{row.actual_pf_employee}</td>
                          <td>{row.calculated_pf_employer}</td>
                          <td>{row.calculated_pf_employee}</td>
                          <td>{row.uan_no}</td>
                          <td>{row.payment_date}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center text-danger fw-bold">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PfReport;
